import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import { getDashboardLink } from '@rd-web-markets/shared/dist/util/getDashboardLink';
import ChevronRightIcon from '@rd-web-markets/shared/dist/util/icons/ChevronRightIcon';

const CompletedClaimGroupCard = ({ claimGroup, accountType, company }) => {
  const { t } = useTranslation();

  const statStyle = {
    borderRight: '1px solid #e5e7eb',
    padding: '0.5rem 3rem 0.5rem 2rem',
  };

  const iconStyle = {
    fontSize: '4.5rem',
    color: '#c0c0c0',
  };

  return (
    <Card className="mb-3" style={{ background: '#f8f9fa', border: '1px solid #e5e7eb' }}>
      <Card.Body className="py-3 px-4">
        <div className="d-flex align-items-center gap-3 mb-3">
          <h4 className="fw-bold mb-0">{claimGroup.name}</h4>
          {claimGroup.report_completion ? (
            <Badge bg="primary" style={{ fontWeight: 500, fontSize: '0.75rem' }}>
              {t('completed') || 'Completed'}
            </Badge>
          ) : (
            <Badge bg="warning" style={{ fontWeight: 500, fontSize: '0.75rem' }}>
              {t('in_progress') || 'In progress'}
            </Badge>
          )}
        </div>

        <Row className="align-items-center">
          <Col style={statStyle}>
            <div className="d-flex align-items-center gap-4">
              <span className="material-icons" style={iconStyle}>work_outline</span>
              <div className="d-flex flex-column justify-content-center">
                <div className="text-muted" style={{ fontSize: '0.9rem' }}>
                  {t('total_projects') || 'Total Projects'}
                </div>
                <div className="fw-bold" style={{ fontSize: '2rem', lineHeight: 1.1 }}>
                  {claimGroup.projects_count ?? '—'}
                </div>
              </div>
            </div>
          </Col>

          <Col style={statStyle}>
            <div className="d-flex align-items-center gap-3">
              <span className="material-icons" style={iconStyle}>military_tech</span>
              <div className="d-flex flex-column justify-content-center">
                <div className="text-muted" style={{ fontSize: '0.9rem' }}>
                  {t('secure_qe') || 'Secure QE (£)'}
                </div>
                <div className="fw-bold" style={{ fontSize: '2rem', lineHeight: 1.1 }}>
                  {claimGroup.total_rnd_amount}
                </div>
              </div>
            </div>
          </Col>

          <Col style={{ ...statStyle, borderRight: 'none' }}>
            <div className="d-flex align-items-center gap-3">
              <span className="material-icons" style={iconStyle}>speed</span>
              <div className="d-flex flex-column justify-content-center">
                <div className="text-muted" style={{ fontSize: '0.9rem' }}>
                  {t('rnd_intensity') || 'R&D Intensity'}
                </div>
                <div className="fw-bold" style={{ fontSize: '2rem', lineHeight: 1.1 }}>
                  {claimGroup.rnd_intensity}%
                </div>
              </div>
            </div>
          </Col>

          <Col xs="auto" className="d-flex align-items-center gap-5 ms-auto">
            <Button
              variant="primary"
              as={Link}
              to={getDashboardLink(company, accountType, claimGroup)}
            >
              {t('dashboard') || 'Dashboard'}
              <span className="material-icons md-18 ms-1" style={{ verticalAlign: 'middle' }}>
                chevron_right
              </span>
            </Button>
            <Link
              to={`/${accountType}/companies/${claimGroup.company_id}/${claimGroup.id}/master`}
              className="text-primary fw-semibold"
            >
              {t('view_claim') || 'View claim'}
              <ChevronRightIcon />
            </Link>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CompletedClaimGroupCard;
